import fetch from "../utils/fetch";
// import { getToken } from "../utils/auth";
// import { stringify } from "qs";

const API_BASE = window.SERVERAPI.API_BASE;

// 新建验收申请
export function AddAcceptanceCheckManagementStart(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_AcceptanceCheckManagement/AddAcceptanceCheckManagementStart",
    method: "post",
    data
  });
}

// 编辑验收申请
export function EditAcceptanceCheckManagementStart(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_AcceptanceCheckManagement/EditAcceptanceCheckManagementStart",
    method: "post",
    data
  });
}

// 删除验收岗位
export function DeleteAcceptanceCheckManagementStart(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_AcceptanceCheckManagement/DeleteAcceptanceCheckManagementStart",
    method: "delete",
    params
  });
}

// 验收分页
export function GetAcceptanceCheckManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_AcceptanceCheckManagement/GetAcceptanceCheckManagementPageList",
    method: "get",
    params
  });
}

// ========  外采接口  ==============
// 外采分页
export function GetOutSourcingManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingManagement/GetOutSourcingManagementPageList",
    method: "get",
    params
  });
}

// 新建外采
export function AddOutSourcingManagement(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingManagement/AddOutSourcingManagement",
    method: "post",
    data
  });
}

// 修改外采
export function EditOutSourcingManagement(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingManagement/EditOutSourcingManagement",
    method: "post",
    data
  });
}

// 提交/审核外采管理
export function AduitOutSourcingManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingManagement/AduitOutSourcingManagement",
    method: "post",
    params
  });
}

// 获取合同性质下拉框 根据类型获取字典
export function GetListByType(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/Dictionary/GetListByType",
    method: "get",
    params
  });
}

// 删除外采信息
export function DeletetOutSourcingManagement(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingManagement/DeletetOutSourcingManagement",
    method: "delete",
    params
  });
}

// 新增外采付款情况
export function PaymentAdd(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingPayment/Add",
    method: "post",
    data
  });
}

// 获取外采付款信息分页
export function GetOutSourcingtPaymentPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingPayment/GetOutSourcingtPaymentPageList",
    method: "get",
    params
  });
}

// 删除外采付款情况
export function OutSourcingPaymentDelete(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_OutSourcingPayment/Delete",
    method: "delete",
    params
  });
}

// 成本 ========================
// 成本分页
export function GetLaborCostGroupPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/GetLaborCostGroupPageList",
    method: "get",
    params
  });
}

// 新增成本批次
export function AddLaborCostGroup(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/AddLaborCostGroup",
    method: "post",
    data
  });
}

// 修改成本批次
export function UpdateLaborCostGroup(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/UpdateLaborCostGroup",
    method: "post",
    data
  });
}

// 删除成本批次
export function DeleteLaborCostGroup(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/DeleteLaborCostGroup",
    method: "delete",
    params
  });
}

// 提交/审核成本批次
export function AduitLaborCostGroup(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/AduitLaborCostGroup",
    method: "post",
    params
  });
}

// 新增成本
export function AddLaborCost(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostManagement/AddLaborCost",
    method: "post",
    data
  });
}

// 获取批次下拉框
export function GetLaborCostGroupList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostGroupManagement/GetLaborCostGroupList",
    method: "get",
    params
  });
}

// 获取成本金额列表
export function GetLaborCostList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostManagement/GetLaborCostList",
    method: "get",
    params
  });
}

// 某一批次下面的成本分页
export function GetLaborCostPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostManagement/GetLaborCostPageList",
    method: "get",
    params
  });
}

// 删除成本
export function DeleteLaborCost(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostManagement/DeleteLaborCost",
    method: "delete",
    params
  });
}

// 修改成本
export function UpdateLaborCost(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_LaborCostManagement/UpdateLaborCost",
    method: "post",
    data
  });
}
// 到期提醒================================
// 根据新增/续约项目ID获取到期提醒
export function GetExpirationReminderList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_ExpirationReminder/GetExpirationReminderList",
    method: "get",
    params
  });
}

// 新增到期提醒
export function ExpirationReminderAdd(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_ExpirationReminder/Add",
    method: "post",
    data
  });
}

// 修改到期提醒
export function ExpirationReminderUpdate(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/P_ExpirationReminder/Update",
    method: "post",
    data
  });
}
